// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
require('whatwg-fetch');
var globalObj = typeof self !== 'undefined' && self || this;
module.exports = globalObj.fetch.bind(globalObj);



//////////////////
// WEBPACK FOOTER
// ../~/fetch-everywhere/fetch-npm-browserify.js
// module id = 983
// module chunks = 0